import React                from "react";
import {SeparatorProps}     from "./@types";
import {block}              from "./block";

export const Separator = ({colSpan, SeparatorElement, index}:SeparatorProps) =>
    <tr className={block.el('tbody-separator-row')}>
        <td className={block.el('tbody-separator-cell')} colSpan={colSpan}>
            {SeparatorElement && <SeparatorElement index={index}/>}
        </td>
    </tr>
;
